/**
 * Created by iamso on 28.08.2019.
 */

const ShopUserGoldView = MinimalDialogue.extend({
    ctor: function () {
        this._super({
            items: this.listItems()
        });

        const scene = cleverapps.Scenes.GetRunningScene();
        scene.addChild(this);
        this.display();

        this.onResize();
    },

    onResize: function () {
        this.setAlignment(cleverapps.styles.ShopUserGoldView);
    },

    listItems: function () {
        const textItems = [this.createGoldBlock()];

        const boosters = ShopUserGoldView.ListBoosters();
        if (boosters.length > 0) {
            textItems.push(this.createBoostersBlock(boosters));
        }

        return textItems;
    },

    createGoldBlock: function () {
        const text = cleverapps.UI.generateOnlyText(Messages.get("YouHaveAmount"), cleverapps.styles.FONTS.SHOP_USER_GOLD_TEXT);

        if (cleverapps.config.type !== "match3" || !cleverapps.environment.isGameScene()) {
            return text;
        }

        const styles = cleverapps.styles.ShopUserGoldView;

        const goldItem = this.createItem(levels.user.gold, RewardTypes.hard.getSmallIcon(), styles.items.gold);

        const goldBlock = new cleverapps.Layout([text, goldItem], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.textNode.goldItemsMargin
        });
        return goldBlock;
    },

    createBoostersBlock: function (boosters) {
        const styles = cleverapps.styles.ShopUserGoldView;

        const boosterItems = boosters.map((booster) => this.createItem(booster.getAmount(), RewardTypes.boosters.getSmallIcon(booster), styles.items.boosters));

        return new cleverapps.WrapGridLayout(boosterItems, {
            direction: cleverapps.UI.HORIZONTAL,
            columns: 3,
            margin: styles.textNode.boostersItemsMargin,
            align: {
                x: cleverapps.GridLayout.ALIGN_CENTER
            }
        });
    },

    createItem: function (amount, iconImage, itemStyles) {
        const styles = cleverapps.styles.ShopUserGoldView;

        const amountText = cleverapps.UI.generateImageText(cleverapps.formatAmount(amount), cleverapps.styles.FONTS.SHOP_USER_GOLD_TEXT);
        const icon = new cc.Sprite(iconImage);
        icon.y += itemStyles.dy || 0;

        return new cleverapps.Layout([amountText, icon], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.items.margin
        });
    },

    getPreferredBundles: function () {
        return ["tile_shop"];
    }
});

ShopUserGoldView.ListBoosters = function () {
    if (["differences", "match3"].indexOf(cleverapps.config.type) !== -1) {
        return cleverapps.boosters.listAll();
    }

    return cleverapps.boosters.listBoostersBefore();
};

ShopUserGoldView.IsAvailable = function () {
    return cleverapps.user.checkAvailable(cleverapps.config.features.includes("boosters_before") && cleverapps.config.availables.BOOSTERS_BEFORE, { ignoreProgress: true }) && ShopUserGoldView.ListBoosters().length;
};

cleverapps.styles.ShopUserGoldView = {
    x: { align: "center" },
    y: { align: "bottom", dy: 10 },

    textNode: {
        margin: 10,
        goldItemsMargin: 10,
        boostersItemsMargin: {
            x: 15,
            y: 15
        }
    },

    items: {
        margin: 5,

        gold: {
            dy: 5
        },

        boosters: {
            dy: 5
        }
    }
};
